import { Selector } from '@ngxs/store';

import { ExternalUnit } from '../../models';
import { UNIT_CONFIGURATION_STATE_TOKEN, UnitConfigurationStateModel } from './unit-configuration.model';

export class UnitConfigurationSelectors {
  @Selector([UNIT_CONFIGURATION_STATE_TOKEN])
  static getUpdatingAccessories(state: UnitConfigurationStateModel): boolean {
    return state.updatingAccessories;
  }

  @Selector([UNIT_CONFIGURATION_STATE_TOKEN])
  static getCurrentSimulationAccessories(state: UnitConfigurationStateModel) {
    return state.currentSimulationAccessories;
  }

  @Selector([UNIT_CONFIGURATION_STATE_TOKEN])
  static getExternalUnits(state: UnitConfigurationStateModel): ExternalUnit[] {
    return state.externalUnitContainer.externalUnits;
  }

  @Selector([UNIT_CONFIGURATION_STATE_TOKEN])
  static isExternalUnitsLoading(state: UnitConfigurationStateModel): boolean {
    return state.externalUnitContainer.isLoading;
  }
}
